<template>
  <div class="terms-and-conditions-container">
    <input
      ref="termsCheckbox"
      id="terms"
      type="checkbox"
      :checked="!!workspaceTermsAcceptedAt"
      @change="toggleAcceptTerms"
    />
    <label for="terms">
      {{ t('TERMS ACCEPTANCE') }}
      <span v-if="clickWrapFeatureEnabled">{{ t('TERMS & CONDITIONS') }}</span>
      <button type="button" v-else class="link" @click="goToTermsView">
        {{ t('TERMS & CONDITIONS') }}
      </button>
    </label>
  </div>
</template>

<script lang="ts">
import { computed, ref, Ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { Client } from 'altru-types';
import { RouteNames } from '@/router';
import { useRouter } from 'vue-router';

export default {
  name: 'TermsAndConditions',
  setup(): {
    workspaceTermsAcceptedAt: Ref<string | null>;
    toggleAcceptTerms: () => void;
    goToTermsView: () => void;
    t: (key: string) => string;
    termsCheckbox: Ref<HTMLInputElement | null>;
    clickWrapFeatureEnabled: Ref<boolean>;
  } {
    const termsCheckbox = ref<HTMLInputElement | null>(null);
    const { t } = useI18n();
    const { getters, dispatch } = useStore();
    const { push } = useRouter();
    const workspaceTermsAcceptedAt: Ref<string | null> = computed(() => getters['clients/workspaceTermsAcceptedAt']);

    const toggleAcceptTerms = () => {
      dispatch(
        'clients/toggleWorkspaceTermsAccepted',
        workspaceTermsAcceptedAt.value ? null : new Date().toISOString(),
      );
    };

    const goToTermsView = () => {
      push({
        name: RouteNames.Terms,
      });
    };

    const client: Ref<Client | null> = computed(() => getters['clients/workspaceInfo']);
    const clickWrapFeatureEnabled: Ref<boolean> = computed(
      () => client.value?.feature_keys?.includes('click_wrap_terms_and_conditions') ?? false,
    );

    return {
      workspaceTermsAcceptedAt,
      toggleAcceptTerms,
      goToTermsView,
      t,
      termsCheckbox,
      clickWrapFeatureEnabled,
    };
  },
};
</script>

<style lang="scss" scoped>
.terms-and-conditions-container {
  text-align: center;
  position: relative;
}
</style>
